// extracted by mini-css-extract-plugin
var _1 = "#68914d";
var _2 = "#9cc681";
var _3 = "#8ab46f";
var _4 = "8px";
var _5 = "6px";
var _6 = "8px";
var _7 = "0 1px 1px 0 rgba(0,0,0,.02) inset";
var _8 = "0 8px 8px -4px rgba(0,0,0,.03),0 16px 24px -4px rgba(0,0,0,.08)";
var _9 = "10px";
var _a = "#e8e8e8";
var _b = "16px 24px";
var _c = "cell___h95rD";
var _d = "#38aa73";
var _e = "#956c22";
var _f = "#2988bd";
var _10 = "#eee";
var _11 = "#c4842d";
var _12 = "#b8567c";
var _13 = "#8b6e4e";
var _14 = "#5889c2";
var _15 = "#4e8a8a";
var _16 = "#6a8a3e";
var _17 = "#7b5ea7";
var _18 = "#4a6fa5";
var _19 = "#3a8a6e";
var _1a = "#c25b4e";
var _1b = "#fafbfc";
var _1c = "#1e3050";
var _1d = "#293d62";
var _1e = "#fafbfc";
var _1f = "rgba(0,0,0,.12)";
var _20 = "#d9d9d9";
var _21 = "rgba(5,5,5,.1)";
var _22 = "#eaf2fc";
var _23 = "rgba(0,0,0,.65)";
var _24 = "#ebebeb";
var _25 = "#068467";
var _26 = "rgba(6,132,103,.1)";
var _27 = "#dc4949";
var _28 = "rgba(220,73,73,.1)";
var _29 = "#787c81";
var _2a = "#d6d9dc";
var _2b = "#f3f5f7";
var _2c = "#73c9b2";
var _2d = "linear-gradient(180deg, #73C9B2 0%, #B8E7DA 100%)";
var _2e = "#b8e7da";
var _2f = "#5357f8";
var _30 = "rgb(14.3921787709,19.9877094972,245.2078212291)";
var _31 = "rgb(249.6189944134,249.7441340782,254.7810055866)";
var _32 = "#f7f8f9";
var _33 = "#edeeef";
var _34 = "#7b8996";
var _35 = "#ededed";
var _36 = "#f4f5f7";
var _37 = "#fbfbfc";
var _38 = "rgba(0,0,0,.75)";
var _39 = "rgba(171.2567039106,172.4612273574,220.9432960894,.95)";
var _3a = "rgba(0,0,0,.3)";
var _3b = "rgba(0,0,0,.5)";
var _3c = "rgba(0,0,0,.4)";
var _3d = "rgba(0,0,0,.95)";
var _3e = "rgba(0,0,0,.65)";
var _3f = "rgba(0,0,0,.85)";
var _40 = "20px";
var _41 = "#f41e28";
var _42 = "1063px";
var _43 = "rgba(227,89,86,.2)";
var _44 = "#e35956";
var _45 = "16px 24px";
var _46 = "28px";
var _47 = "32px";
var _48 = "18px";
var _49 = "14px";
var _4a = "14px";
var _4b = "15px";
var _4c = "12.6px";
var _4d = "11px";
var _4e = "20px";
var _4f = "28px";
var _50 = "700";
var _51 = "200";
var _52 = "300";
var _53 = "500";
var _54 = "400";
var _55 = "600";
var _56 = "hsla(0,0%,100%,.2)";
var _57 = "#ccc";
var _58 = "49px";
var _59 = "5px";
var _5a = "#5357f8";
var _5b = "rgba(0,0,0,.4)";
var _5c = "#fafafa";
var _5d = "hsla(0,0%,100%,.9)";
var _5e = "rank___QdDMZ";
var _5f = "root___DSMVM";
var _60 = "15px";
var _61 = "20px";
var _62 = "24px";
var _63 = "hsla(0,0%,100%,.6)";
var _64 = "#7e7eff";
var _65 = "hsla(0,0%,100%,.7)";
var _66 = "hsla(0,0%,100%,.3)";
var _67 = "hsla(0,0%,100%,.575)";
var _68 = "60px";
var _69 = "208px";
var _6a = "rgba(82,196,26,.2)";
var _6b = "#52c41a";
var _6c = "12px";
var _6d = "20px";
var _6e = "rgba(250,173,20,.2)";
var _6f = "#faad14";
var _70 = "#fff";
var _71 = "hsla(0,0%,100%,.2)";
export { _1 as "actionButtonColorDark", _2 as "actionButtonColorLight", _3 as "actionButtonColorMedium", _4 as "borderRadiusCard", _5 as "borderRadiusMain", _6 as "borderRadiusSurface", _7 as "boxShadowInnerXs", _8 as "boxShadowXl", _9 as "btnRightMargin", _a as "cardBorderColor", _b as "cardPadding", _c as "cell", _d as "changeSetCompletedColor", _e as "changeSetManuallyChangesProposed", _f as "changeSetScheduledChangesProposed", _10 as "chipBackground", _11 as "colorAccentAmber", _12 as "colorAccentBerry", _13 as "colorAccentBrown", _14 as "colorAccentCornflower", _15 as "colorAccentCyan", _16 as "colorAccentOlive", _17 as "colorAccentPurple", _18 as "colorAccentSteelBlue", _19 as "colorAccentTeal", _1a as "colorAccentTerracotta", _1b as "colorBackgroundMain", _1c as "colorBackgroundSidebar", _1d as "colorBackgroundSidebarHover", _1e as "colorBackgroundTabs", _1f as "colorBorderContainer", _20 as "colorBorderMain", _21 as "colorBorderSecondary", _22 as "colorDeltaCyanBlueBg", _23 as "colorDeltaGray", _24 as "colorDeltaGrayBg", _25 as "colorDeltaGreen", _26 as "colorDeltaGreenBg", _27 as "colorDeltaRed", _28 as "colorDeltaRedBg", _29 as "colorDetailsFieldText", _2a as "colorDetailsIcon", _2b as "colorDetailsTagBg", _2c as "colorMint", _2d as "colorMintGradient", _2e as "colorMintLight", _2f as "colorPrimary", _30 as "colorPrimaryHover", _31 as "colorPrimaryLightened", _32 as "colorTableHeadBg", _33 as "colorTableHeadBgHover", _34 as "colorTableHeadSubtitle", _35 as "colorTableRowBorder", _36 as "colorTableTextBg", _37 as "colorTableTotalRowBg", _38 as "colorTextBase", _39 as "colorTextDisabled", _3a as "colorTextExtraLight", _3b as "colorTextLight", _3c as "colorTextLighter", _3d as "colorTextMainHeading", _3e as "colorTextMuted", _3f as "colorTextPrimary", _40 as "contentHorizPadding", _41 as "dangerColor", _42 as "dashboardPdfContentWidth", _43 as "errorBackcolor", _44 as "errorColor", _45 as "filterPanelPadding", _46 as "filtersDefaultHeight", _47 as "filtersTallHeight", _48 as "fontSizeLarge", _49 as "fontSizeMain", _4a as "fontSizeMedium", _4b as "fontSizePlus", _4c as "fontSizeSmaller", _4d as "fontSizeSmallest", _4e as "fontSizeXLarge", _4f as "fontSizeXxLarge", _50 as "fontWeightBold", _51 as "fontWeightExtraLight", _52 as "fontWeightLight", _53 as "fontWeightMediumBold", _54 as "fontWeightNormal", _55 as "fontWeightSemiBold", _56 as "ghostWhite", _57 as "grayBackgroundColor", _58 as "headerHeight", _59 as "iconHorizontalMargin", _5a as "linkColor", _5b as "linkColorMuted", _5c as "popoverHeaderColor", _5d as "popoverMaskColor", _5e as "rank", _5f as "root", _60 as "rowPadding", _61 as "ruleInnerGutters", _62 as "ruleSideGutters", _63 as "sideMenuIconColor", _64 as "sideMenuIconSelectedColor", _65 as "sideMenuItemColor", _66 as "sideMenuScrollbarThumbColor", _67 as "sideMenuSubmenuItemColor", _68 as "sidebarCollapsedWidth", _69 as "sidebarWidth", _6a as "successBackcolor", _6b as "successColor", _6c as "tableHeaderVerticalPadding", _6d as "tableHorizPadding", _6e as "warningBackcolor", _6f as "warningColor", _70 as "whiteColor", _71 as "whiteDividerColor" }
